import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';


import {getTranslation} from 'fetch'

import * as S from './styled';

const Select = ({ geoData, setTLocation }) => {
  const { i18n } = useTranslation();

  const changeLanguage = ({ target: { value } }) => {
    i18n.changeLanguage(value);
    localStorage.lng = value;
    getTranslation(geoData, setTLocation);
  };
  return (
    <S.Select defaultValue={localStorage.lng} onChange={changeLanguage}>
      <S.Option value="en">EN</S.Option>
      <S.Option value="ru">RU</S.Option>
      <S.Option value="by">BY</S.Option>
    </S.Select>
  );
};

export default Select;

Select.defaultProps = {
  geoData: null,
}

Select.propTypes = {
  setTLocation: PropTypes.func.isRequired,
  geoData: PropTypes.shape({
    lat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    lng: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    DMS: PropTypes.shape({
      lat: PropTypes.string,
      lng: PropTypes.string,
    }),
    location: PropTypes.string,
    offsetSec: PropTypes.number,
  }),
};